// extracted by mini-css-extract-plugin
export var card = "rich_link-module--card--Jk5-3";
export var content = "rich_link-module--content--1eTYN";
export var image = "rich_link-module--image--rpXlT";
export var title = "rich_link-module--title--2b4OE";
export var description = "rich_link-module--description--3ilzY";
export var domain = "rich_link-module--domain--1_xZE";